import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { IRoutes } from 'routes/route-lists';

interface INavLink {
  routes: IRoutes;
  toggle: () => void;
  isDivider?: boolean;
  key: number;
}
let i = 0;
const CustomNavlink: FC<INavLink> = ({ routes, isDivider, toggle, key }) => {
  i += 1;

  return (
    <>
      <li className="nav-item" onClick={toggle} key={key + i}>
        <NavLink className="nav-link menu-link " to={routes.path}>
          {routes.icon} <span data-key="t-widgets">{routes.title}</span>
        </NavLink>
        {isDivider ? (
          <>
            <hr className="bg-danger border border-1 mx-3 my-1" />{' '}
          </>
        ) : (
          ''
        )}
      </li>
    </>
  );
};

export default CustomNavlink;
